import BuktiKaryaCategoryIndex from 'app/ProfileRevampPage/pages/BuktiKarya/CategoryIndex'
import { getDeviceId } from 'utils/deviceId'

export async function getServerSideProps(ctx) {
  return {
    props: {
      appDeviceID: getDeviceId(ctx),
    },
  }
}

const ProfilBuktiKaryaCategoryPage = () => {
  return <BuktiKaryaCategoryIndex />
}

ProfilBuktiKaryaCategoryPage.Layout = ({ children }) => children

export default ProfilBuktiKaryaCategoryPage
